export default "__VITE_ASSET__qZQ$ZwTb__"